module.exports = __webpack_public_path__ + "img/superwords.f12f03af.png";